"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
function renderQueryResult(result, renderers) {
    if (result.loading) {
        return renderers.renderLoading ? renderers.renderLoading() : null;
    }
    if (result.error) {
        var errorCode = data_catalog_shared_1.getFirstGraphQLErrorCode(result.error);
        if (result.data) {
            if (renderers.renderDataWithError) {
                return renderers.renderDataWithError(result.data, errorCode);
            }
            else {
                return (React.createElement(React.Fragment, null,
                    renderers.renderData(result.data),
                    data_catalog_shared_1.reportGraphQLError(errorCode)));
            }
        }
        else {
            return renderers.renderError ? renderers.renderError(errorCode) : data_catalog_shared_1.reportGraphQLError(errorCode);
        }
    }
    if (result.data) {
        return renderers.renderData(result.data);
    }
    return renderers.renderNoData ? renderers.renderNoData() : data_catalog_shared_1.reportNoData();
}
exports.renderQueryResult = renderQueryResult;
//# sourceMappingURL=renderQueryResult.js.map